/* The Woolshire rebrand 2026: brand header behaviour (snippets/woolshire-header.liquid).
   - Desktop dropdown panels: open on hover (mouse), on click/tap of the chevron, from the keyboard
     (Enter/Space/ArrowDown on the chevron); aria-expanded kept in sync; Esc closes and returns focus;
     focus leaving the item, a click outside, or opening another panel closes it. A first tap on a
     parent link on a touch screen opens its panel instead of navigating; the second tap navigates.
   - Burger aria-expanded mirrors the theme drawer (startup.js DrawerNav sets data-open on it).
   - Drawer rows with children expand in place (aria-expanded + hidden).
   - Sticky header slims after 80px of scroll (back under 20px). The header section keeps its
     footprint (the slimmer bar is compensated with margin-bottom), so nothing below moves.
   Vanilla, no dependencies. */
(function () {
  'use strict';
  var hdr = document.querySelector('[data-ws-hdr]');
  if (!hdr) return;
  var desktop = window.matchMedia('(min-width: 1024px)');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

  // ---------- desktop panels ----------
  var items = Array.prototype.slice.call(hdr.querySelectorAll('[data-ws-nav-item]'));
  var openItem = null, closeTimer = null, openTimer = null, lastPointer = 'mouse';
  function parts(li) { return { t: li.querySelector('[data-ws-nav-toggle]'), p: li.querySelector('[data-ws-panel]'), a: li.querySelector('.ws-nav__link') }; }
  function close(li, focusToggle) {
    if (!li) return;
    var x = parts(li);
    x.p.hidden = true; x.t.setAttribute('aria-expanded', 'false'); li.classList.remove('is-open');
    if (openItem === li) openItem = null;
    if (focusToggle) x.t.focus();
  }
  function open(li) {
    clearTimeout(closeTimer);
    if (openItem && openItem !== li) close(openItem);
    var x = parts(li);
    x.p.hidden = false; x.t.setAttribute('aria-expanded', 'true'); li.classList.add('is-open');
    openItem = li;
  }
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);
  items.forEach(function (li) {
    var x = parts(li);
    li.addEventListener('mouseenter', function () {
      if (!desktop.matches || !hoverable.matches || lastPointer === 'touch') return;
      clearTimeout(closeTimer); clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(li); }, openItem ? 0 : 90);
    });
    li.addEventListener('mouseleave', function () {
      if (!hoverable.matches || lastPointer === 'touch') return;
      clearTimeout(openTimer);
      if (openItem !== li || li.dataset.pinned === '1') return;
      closeTimer = setTimeout(function () { close(li); }, 160);
    });
    x.t.addEventListener('click', function () {
      clearTimeout(openTimer);
      if (openItem === li && li.dataset.pinned === '1') { li.dataset.pinned = ''; close(li); return; }
      if (openItem === li && li.dataset.pinned !== '1' && lastPointer !== 'mouse') { close(li); return; }
      open(li); li.dataset.pinned = '1';
    });
    x.t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault(); open(li); li.dataset.pinned = '1';
        var first = x.p.querySelector('a'); if (first) first.focus();
      }
    });
    // touch screens at desktop width: first tap on the parent link opens its panel
    x.a.addEventListener('click', function (e) {
      if (lastPointer === 'touch' && openItem !== li) { e.preventDefault(); open(li); li.dataset.pinned = '1'; }
    });
    li.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !li.contains(e.relatedTarget) && openItem === li) { li.dataset.pinned = ''; close(li); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && openItem) {
      var li = openItem; li.dataset.pinned = '';
      close(li, li.contains(document.activeElement) || document.activeElement === document.body);
    }
  });
  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) { openItem.dataset.pinned = ''; close(openItem); }
  });
  desktop.addEventListener && desktop.addEventListener('change', function () { if (openItem) close(openItem); });

  // ---------- burger aria-expanded mirrors the theme drawer ----------
  var drawer = document.querySelector('[data-drawer-nav]');
  var burger = hdr.querySelector('[data-menu-button]');
  if (drawer && burger) {
    var sync = function () { burger.setAttribute('aria-expanded', drawer.dataset.open === 'true' ? 'true' : 'false'); };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['data-open'] });
    sync();
    // drawer rows with children
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-ws-drawer-toggle]'), function (b) {
      b.addEventListener('click', function () {
        var sub = document.getElementById(b.getAttribute('aria-controls'));
        var on = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (sub) sub.hidden = !on;
      });
    });
  }

  // ---------- slim on scroll ----------
  var sec = hdr.closest('.main-header-section') || hdr.parentElement;
  var slim = false, ticking = false;
  function check() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset;
    var want = slim ? y > 20 : y > 80;
    if (want === slim) return;
    slim = want;
    hdr.classList.toggle('is-slim', slim);
    if (sec) sec.classList.toggle('ws-hdr-slim', slim);
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
  check();
})();
